import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DraggableWorkout from './DraggableWorkout';
import { Pagination } from '@mui/material';

const WorkoutsList = ({ workouts }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;

  // Calculate the index of the first and last workout to display
  const indexOfLastWorkout = currentPage * itemsPerPage;
  const indexOfFirstWorkout = indexOfLastWorkout - itemsPerPage;
  const currentWorkouts = workouts.slice(indexOfFirstWorkout, indexOfLastWorkout);

  // Handle page change
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <div>
      <div>
        {currentWorkouts.map((workout) => (
          <DraggableWorkout key={workout.id} workout={workout} />
        ))}
      </div>
      <Pagination
        count={Math.ceil(workouts.length / itemsPerPage)}
        page={currentPage}
        onChange={handlePageChange}
        color="primary"
        sx={{ marginTop: '16px', display: 'flex', justifyContent: 'center' }}
      />
    </div>
  );
};

WorkoutsList.propTypes = {
  workouts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      equipmentNeeded: PropTypes.bool.isRequired,
      categoryName: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default WorkoutsList;
